import { Component, OnInit, Input, OnChanges, SimpleChange } from '@angular/core';
import { Router } from '@angular/router';
import { AppService, AppSettingService } from '../../app.service';

@Component({
    selector: 'app-map-icon',
    template: `<i (click)="gotoMap()" class="fas fa-map-marker-alt jmMapIcon" [ngClass]="{'jmMapIconDisabled':(enable===false)}" ngbTooltip="{{toolTip}}" container="body" placement="{{tipPos}}"></i>`,
    styleUrls: ['./map-icon.scss'],
    standalone: false
})
export class MapIconComponent implements OnInit {
	@Input() mapObjectId: string = ""; 
	@Input() enable: boolean = false;
	@Input() tipPos: "left" | "top" | "bottom" | "" = ""; // display tooltip at left/right/top/bottom default is empty (not display)
	@Input() go: boolean = false; // when click outside text
	@Input() hasMany: boolean = false; // do nothing if has muliplte instances

	constructor(
		private appService: AppService,
		private router: Router
	) {}

	toolTip: string = ""

	gotoMap(): void {
		if (this.enable && !this.hasMany) {
			if (this.appService.fromEmbedOccupations) {
				window.open(AppSettingService.baseUrl + "/Map?ObjectID=" + encodeURIComponent(this.mapObjectId), "_blank");				          
			}
			else {
				window.location.href = (AppSettingService.baseUrl + "/Map?ObjectID=" + encodeURIComponent(this.mapObjectId));
			}
		}
	}

	ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
		if (changes['mapObjectId']) {
			this.mapObjectId = this.mapObjectId.trim();
			this.ngOnInit();
		}
		//this watch provides a way to know if user clicked on some text, such as label from parent of this directive.
		else if (changes['go']) {
			if (this.go) {
				this.gotoMap();
			}
		}
	}

	ngOnInit(): void {
		this.toolTip = this.tipPos === "" || this.mapObjectId === "" ? "" : "Map";
	}
}
